<template>
  <div class="mediaMessage">
    <div class="mediaMessage_icon">
      <img src="@/assets/images/icon/person.svg" alt="" />
      <span>{{ person }}</span>
    </div>
    <div class="mediaMessage_main">
      <ExpandedText :text="message" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core'
import ExpandedText from '@/components/elements/ExpandedText.vue'

export default defineComponent({
  components: {
    ExpandedText
  },

  props: {
    person: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.mediaMessage {
  display: flex;
  width: 100%;

  & + & {
    margin-top: 30px;
  }

  &_icon {
    flex-basis: 70px;
    flex-shrink: 0;
    margin-right: 20px;
    text-align: center;
    line-height: 1.5;
    font-size: 1.2rem;

    @include mixins.media() {
      flex-basis: 90px;
    }

    img {
      display: block;
      width: 100%;
      margin-bottom: 8px;
    }
  }
}
</style>
